import { FunctionComponent } from "react";
import { ITextareaProps } from "./interfaces/ITextareaProps";
import "./styles/textarea.css";

export const Textarea: FunctionComponent<ITextareaProps> = (props) => {
    const className = props.className === undefined ? `cui-textarea` : `cui-textarea ${props.className}`;

    return (
        <textarea
            className={className}
            value={props.value}
            onChange={(e) => props.onChange(e.currentTarget.value)}
            aria-describedby={props.ariaDescribedBy}
            aria-label={props.ariaLabel}
            required={props.required}
        />
    );
};
